<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FeBxeC/tc-custom/9781948239608.jpg?1726444339335" alt="This image is the cover for the book Encyclopedia of the Ted Bundy Murders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Encyclopedia of the Ted Bundy Murders
      </h1>
      <p class="bookDescription body article font2">
        <b>The Bundy expert’s authoritative A-to-Z guide to the people and locations involved in the case against America’s most infamous serial killer.</b><br/>  <br/> True crime author of <i>The Bundy Murders</i> Kevin M. Sullivan provides a comprehensive guide to the notorious murderer’s life and crimes. This alphabetized volume lists hundreds of people involved in the case as well as dozens of locations where significant events occurred. This veritable “Who’s Who” of the Bundy murders is an essential reference for researchers and students of the subject.<br/><br/> "Sullivan's A-to-Z coverage of Ted Bundy provides a solid guide to the people and places that define the man and the monster, including some not present in other Bundy narratives. It nicely rounds out his Bundy oeuvre and gives readers an extensive reference tool on one of the world's most infamous serial killers."—Katherine Ramsland, author of Confession of a Serial Killer
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Sullivan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65fc29df